import request, { formatRequest } from "@/utils/request"

import {
  CollectionListData,
  IReviewsNotify,
  ProductListData,
  ProductListParams,
  saveCommonSwitchProps,
  TimeZonesData,
} from "./type"

const ATLAS_GRAPHQL_ENDPOINT = "https://atlas.shopifysvc.com/graphql"

const queryTimeZones = `
  query TimeZones($locale: SupportedLocale!) {
    timeZones(locale: $locale) {
      olsonName
      description
    }
  }
`

const APICommon = {
  // 保存小部件设置
  saveCommonSwitch(params: saveCommonSwitchProps) {
    return formatRequest(
      request.post("/go-api/v1/com/shop/extra_enable", params),
      {
        success: {
          1000: t("SavedSuccessfully"),
        },
        error: {
          "*": t("SavedFailed"),
        },
      },
    )
  },
  getProductList(data: ProductListParams) {
    return formatRequest<ProductListData>(
      request.post("/go-api/v1/block/products", data),
      {
        error: {
          "*": t("ServerError"),
        },
      },
    )
  },
  getCollectionList(data: ProductListParams) {
    return formatRequest<CollectionListData>(
      request.post("/go-api/v1/block/collections", data),
      {
        error: {
          "*": t("ServerError"),
        },
      },
    )
  },
  // 钉钉推送
  updateReviewsNotify(data: IReviewsNotify) {
    return formatRequest(request.post("/go-api/v1/com/ding/notify", data), {
      error: {
        "*": t("ServerError"),
      },
    })
  },
  async fetchTimeZones(variables: { locale: string }) {
    const res = await fetch(ATLAS_GRAPHQL_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: queryTimeZones,
        variables,
      }),
    })

    const json = await res.json()
    return json.data as TimeZonesData
  },
}

export default APICommon
